// Libs
import React from 'react';
// Utils
import { getSelectedPayments } from 'utils/filters/Billings/payments';
// Components
import { AddIcon } from 'components';
import { CustomToolbar } from '../../sharedFunctions';
import ToolbarBackButton from '../../ToolbarBackButton';
// Styles
import '../../index.css';

export function PaymentOrders(props) {
	const {
		title,
		handleOnClick,
		payments,
		api,
		selectNotification,
		mutate1ObjectInBillings,
	} = props;
	const { pays, getPaycutsModal } = payments;

	const selectedPayments = getSelectedPayments(
		api.payments.pays.data,
		pays.selected.items,
	);
	const firstSelectedPayment = selectedPayments[0];

	return (
		<CustomToolbar
			selectNotification={selectNotification}
			title={title}
			left={<ToolbarBackButton handleOnClick={handleOnClick} />}
			right={
				<>
					{/* ENTER INVOICE ORDERS */}
					{getPaycutsModal.type === 'invoice' &&
						selectedPayments.length === 1 &&
						firstSelectedPayment?.state === 'open' && (
							<AddIcon
								button
								onClick={() =>
									mutate1ObjectInBillings('enterInvoiceOrdersModal', {
										isOpen: true,
									})
								}
							/>
						)}
				</>
			}
		/>
	);
}
